export enum enumEntrySummaryStep {
  IM = 'IM',
  CN = 'CN',
  BY = 'BY',
  SP = 'SP',
  INVOICE = 'INVOICE',
  INVOICE_ITEM = 'INVOICE_ITEM',
  SHIP = 'SHIP',
  DOCS = 'DOCS',
  BOND = 'BN',
  SUM = 'ES_SUM',
  BL = 'BL',
  TYPE = 'TYPE',
}
